import { Container, useState } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";

function CheckBox({ showHeatwave, setshowHeatwave }) {
  return (
    <Container fluid className="Checkbox">
      <Card className="Checkbox_card">
        <Card.Body>
          <Form>
            <Form.Check
              type="switch"
              id="custom-switch"
              label="Heatwave Watch"
              checked={showHeatwave}
              onClick={() => setshowHeatwave((val) => !val)}
            />
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default CheckBox;
